import { makeStyles } from "@mui/styles";

const useStyles: any = makeStyles(() => ({
  dialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    padding: "12px 16px",
    borderBottom: "1px solid #d5d2d5",
    backgroundColor: "#f6f6f7"
  },

  titleLeft: {
    display: "flex",
    alignItems: "center",
    gap: "10px"
  },

  titleText: {
    fontSize: "16px",
    fontWeight: 500,
    color: "#4b1c46"
  },

  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    padding: "48px 0"
  },

  dialogContent: {
    padding: "8px 16px",
    // MUI zeroes padding-top on a DialogContent that follows a DialogTitle
    // (`.MuiDialogTitle-root + .MuiDialogContent-root`); that rule outranks a
    // single class, so restore it at matching specificity.
    "&.MuiDialogContent-root": {
      paddingTop: "8px"
    }
  },

  row: {
    display: "flex",
    alignItems: "baseline",
    justifyContent: "space-between",
    gap: "24px",
    padding: "12px 0",
    borderBottom: "1px solid #eeecee",
    "&:last-child": {
      borderBottom: "none"
    }
  },

  label: {
    fontSize: "14px",
    color: "#736973",
    whiteSpace: "nowrap"
  },

  value: {
    display: "flex",
    alignItems: "baseline",
    gap: "12px",
    fontSize: "14px",
    color: "#333",
    textAlign: "right",
    wordBreak: "break-word"
  },

  valueDetail: {
    fontSize: "12px",
    color: "#8f8a8f"
  },

  divider: {
    margin: "12px 0"
  },

  fieldsHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    marginBottom: "10px"
  },

  sectionTitle: {
    fontSize: "12px",
    fontWeight: 500,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    color: "#8f8a8f"
  },

  accordion: {
    border: "1px solid #e5e2e5",
    borderBottom: "none",
    "&:last-of-type": {
      borderBottom: "1px solid #e5e2e5"
    },
    "&:before": {
      display: "none"
    }
  },

  accordionTitle: {
    fontSize: "13px",
    fontWeight: 500,
    color: "#4b1c46"
  },

  fieldCount: {
    fontWeight: 400,
    color: "#8f8a8f"
  },

  accordionDetails: {
    padding: "0 16px 8px",
    backgroundColor: "#fbfafb"
  },

  fieldRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: "24px",
    padding: "4px 0",
    fontFamily: "monospace",
    fontSize: "12px"
  },

  fieldKey: {
    color: "#4b1c46",
    wordBreak: "break-all"
  },

  fieldValue: {
    color: "#333",
    textAlign: "right",
    wordBreak: "break-all"
  },

  emptyText: {
    textAlign: "center",
    fontSize: "14px",
    fontStyle: "italic",
    color: "#8f8a8f",
    padding: "32px 0"
  },

  dialogActions: {
    padding: "8px 16px",
    borderTop: "1px solid #eeecee"
  }
}));

export default useStyles;
